// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2Wq8C","content":"LoadingAlert_content__QB4Ra"};